<template>
  <v-container 
    v-if="(objPregunta.PREGUNTA.HABILITADO_PREGUNTA == true && (objPregunta.PREGUNTA.ID_PREGUNTA_DEPENDIENTE == null || objPregunta.PREGUNTA.ID_PREGUNTA_DEPENDIENTE == 0)) || mostrarPregunta" 
    fluid
  >
    <label v-if="objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA != 6 ? true : objPregunta.PREGUNTA.PARAMETRO_VISIBLE">{{objPregunta.PREGUNTA.NOMBRE_PREGUNTA}}</label>

    <v-row v-if="objPregunta.PREGUNTA.TIENE_IMAGEN == true" class="d-flex justify-center" >
      <v-col cols="12"  class="d-flex justify-center">
        <v-skeleton-loader v-if="loadingImg" type="image" />
        <img v-else v-bind:src="imgPregunta" style="max-width:100%; max-height:200px;"></img>    
      </v-col>
    </v-row>

    <!-- Tipo de pregunta TEXTO -->
    <v-text-field
      v-if="objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 1"
      v-model="valor1"
      solo
      :required="objPregunta.PREGUNTA.REQUERIDA==true"
      :rules="[(v) => objPregunta.PREGUNTA.REQUERIDA == true ? ( !!v || 'Campo obligatorio') : true]"
      @input="setRespuesta(idSeccion, objPregunta.PREGUNTA.ID_PREGUNTA, 0, valor1, 0, false)"
      :readonly="consulta"
    >

    </v-text-field>
    

    <!-- Tipo de pregunta NUMERICO -->
    <!-- NUMERO LIBRE -->
    <v-text-field
      v-if="objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 2 && objPregunta.PREGUNTA.SELECTOR_NUMERICO == false"
      v-model="valor2"
      type="number"
      solo
      :rules="[reglas2.required(valor2), reglas2.min(valor2, objPregunta.PREGUNTA.VALOR_MINIMO), reglas2.max(valor2, objPregunta.PREGUNTA.VALOR_MAXIMO)]"
      :required="objPregunta.PREGUNTA.REQUERIDA == true"
      @input="setRespuesta(idSeccion, objPregunta.PREGUNTA.ID_PREGUNTA, 0, valor2, 0, false)"
      :readonly="consulta"
    ></v-text-field>

    <!-- SELECTOR NUMERICO -->
    <div v-if="objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 2 && objPregunta.PREGUNTA.SELECTOR_NUMERICO == true" class="mt-4">

      <v-slider        
        v-model="valor2"
        :min="objPregunta.PREGUNTA.VALOR_MINIMO"
        :max="objPregunta.PREGUNTA.VALOR_MAXIMO"
        :thumb-size="15"
        thumb-label="always"
        ticks="always"
        :tick-labels="ticksLabels"
        tick-size="5"            
        :required="objPregunta.PREGUNTA.REQUERIDA == true"
        :rules="[(v) => v != null || 'Campo obligatorio']"
        @input="setRespuesta(idSeccion, objPregunta.PREGUNTA.ID_PREGUNTA, 0, valor2, 0, false)"
        :readonly="consulta"
      >      
      </v-slider>
    </div>
    
    <!-- Tipo de pregunta RADIO CON MENOS DE CINCO OPCIONES -->
    <div v-if="objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 3">
      <div v-if="objPregunta.ARREGLO_RESPUESTA != null">
        <!-- CUANDO SON POCAS OPCIONES -->
  
        <v-radio-group 
        v-if="objPregunta.ARREGLO_RESPUESTA.length <= 6"
          v-model="valor3Corto" 
          :row="objPregunta.PREGUNTA.HORIZANTAL"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          :required="objPregunta.PREGUNTA.REQUERIDA == true"
          :readonly="consulta"
        
          >
            <v-row  no-gutters  v-if="objPregunta.PREGUNTA.HORIZANTAL"  >
      
         <v-col   v-for="n in objPregunta.ARREGLO_RESPUESTA">
          <v-radio
            
            :key="'pregunta' + objPregunta.PREGUNTA.ID_PREGUNTA + '_opcion' + n.RESPUESTA.ID_CAT_RESPUESTA"
            :label="n.RESPUESTA.RESPUESTA"
            :value="n.RESPUESTA.ID_CAT_RESPUESTA"
            
          ></v-radio>
         </v-col>
        </v-row>
        <v-radio v-else
            v-for="n in objPregunta.ARREGLO_RESPUESTA"
            :key="'pregunta' + objPregunta.PREGUNTA.ID_PREGUNTA + '_opcion' + n.RESPUESTA.ID_CAT_RESPUESTA"
            :label="n.RESPUESTA.RESPUESTA"
            :value="n.RESPUESTA.ID_CAT_RESPUESTA"
            
          ></v-radio>
         
        </v-radio-group>
      
      

        <!-- CUANDO SON MUCHAS OPCIONES -->
        <v-select
          v-else
          v-model="valor3Corto"
          :items="objPregunta.ARREGLO_RESPUESTA"
          item-value="RESPUESTA.ID_CAT_RESPUESTA"
          item-text="RESPUESTA.RESPUESTA"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          solo
          :required="objPregunta.PREGUNTA.REQUERIDA == true"
          :readonly="consulta"
        ></v-select>


        <v-text-field
          v-if="isValor3CortoTextoLibre"
          v-model="valor3CortoTextoLibre"
          placeholder="Por favor especifique su respuesta"
          solo
          :rules="[(v) => !!v || 'Campo obligatorio']"
          :required="isValor3CortoTextoLibre"
          @input="setRespuesta(idSeccion, objPregunta.PREGUNTA.ID_PREGUNTA, valor3Corto, valor3CortoTextoLibre, valor3ValorNum, isValor3CortoTextoLibre)"
          :readonly="consulta"
        ></v-text-field>
      </div>
      
    </div>

    <!-- Tipo de pregunta CHECKBOX -->
    <div v-if="objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 4">
      
      <div v-if="objPregunta.ARREGLO_RESPUESTA != null">

        <!-- CUANDO SON POCAS OPCIONES -->
        <div v-if="objPregunta.ARREGLO_RESPUESTA.length <= 6">
          <v-row>
            <v-col
              v-for="n in objPregunta.ARREGLO_RESPUESTA"
              :key="'col_pregunta' + objPregunta.PREGUNTA.ID_PREGUNTA + '_opcion' + n.RESPUESTA.ID_CAT_RESPUESTA"
            >
              <v-checkbox
                v-model="valor4"              
                :label="n.RESPUESTA.RESPUESTA"
                :value="n.RESPUESTA.ID_CAT_RESPUESTA"
                :rules="reglas4"
                hide-details
                :readonly="consulta"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="valor4.length==0 && vistaPrevia == false">
            <v-col cols="12" style="padding: 0px;">
              <p style="padding-left:24px; font-size:12px; color: #ff5252 !important; caret-color: #ff5252 !important;">Debe seleccionar por lo menos una opción</p>
            </v-col>
          </v-row>
        </div>

        <!-- CUANDO SON MUCHAS OPCIONES -->
        <div v-else>
          <v-row>
            <v-col>
              <v-select
                v-model="valor4"
                :items="objPregunta.ARREGLO_RESPUESTA"
                item-value="RESPUESTA.ID_CAT_RESPUESTA"
                item-text="RESPUESTA.RESPUESTA"
                :rules="reglas4"
                solo
                multiple
                :required="objPregunta.PREGUNTA.REQUERIDA == true"
                hide-details
                :readonly="consulta"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip>
                    <span>{{ item.RESPUESTA.RESPUESTA }}</span>
                  </v-chip>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row v-if="valor4.length==0 && vistaPrevia == false">
            <v-col cols="12" style="padding: 0px;">
              <p style="padding-left:24px; font-size:12px; color: #ff5252 !important; caret-color: #ff5252 !important;">Debe seleccionar por lo menos una opción</p>
            </v-col>
          </v-row>
        </div>

        <v-text-field
          v-if="isValor4TextoLibre"
          v-model="valor4TextoLibre"
          placeholder="Por favor especifique su respuesta"
          solo
          :rules="[(v) => !!v || 'Campo obligatorio']"
          :required="isValor4TextoLibre"
          @input="setRespuesta(idSeccion, objPregunta.PREGUNTA.ID_PREGUNTA, null, valor4TextoLibre, null, null)"
          :readonly="consulta"
        ></v-text-field>
      </div>
    </div>

    <!-- Tipo de pregunta FECHA -->
    <v-menu
        v-if="objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 5"
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="valor5"
        transition="scale-transition"
        offset-y
        min-width="290px"
        :readonly="consulta"
        :disabled="consulta"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="computedFormatFecha"
            prepend-inner-icon="event"
            readonly
            v-bind="attrs"
            v-on="on"
            solo
            :rules="[(v) => !!v || 'Campo obligatorio']"
            :required="objPregunta.PREGUNTA.REQUERIDA == true"
            :readonly="consulta"
          ></v-text-field>
        </template>
        <v-date-picker v-model="valor5" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false">Cancelar</v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(valor5)">OK</v-btn>
        </v-date-picker> 
      </v-menu>


         <!-- Tipo de pregunta PARAMETRO -->
      <v-text-field
        v-if="objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 6 && objPregunta.PREGUNTA.PARAMETRO_VISIBLE == true"
        v-model="valor6"
        solo
        :readonly="consulta || encuestaAutenticada"
        :required="objPregunta.PREGUNTA.REQUERIDA == true"
        :rules="[(v) => objPregunta.PREGUNTA.REQUERIDA == true ? ( !!v || 'Campo obligatorio') : true]"
        @input="!encuestaAutenticada ? setRespuesta(idSeccion, objPregunta.PREGUNTA.ID_PREGUNTA, 0, valor6, 0, false) :  false"
      ></v-text-field>
  <!--     <v-text-field
        v-if="objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 6 && objPregunta.PREGUNTA.PARAMETRO_VISIBLE == true"
        v-model="valor6"
        solo
        readonly
        :required="objPregunta.PREGUNTA.REQUERIDA == true"
        :rules="[(v) => objPregunta.PREGUNTA.REQUERIDA == true ? ( !!v || 'Campo obligatorio') : true]"
        @input="setRespuesta(idSeccion, objPregunta.PREGUNTA.ID_PREGUNTA, 0, valor6, 0, false)"
      ></v-text-field> -->


        <!-- Tipo de pregunta ORDENAMIENTO -->
        <div v-if="objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 7">
          <v-btn
            v-if="(puedeValor7TextoLibre == true && isValor7TextoLibre == false) && !consulta"
            small
            color="success"
            class="my-2"
            @click="isValor7TextoLibre = true"
          >
            <v-icon small left>mdi-playlist-plus</v-icon>
            Agregar respuesta
          </v-btn>
          <v-list two-line subheader>
                <draggable 
                  :list="valor7" 
                  v-bind="dragOptions"
                  @start="drag = true"
                  @end="drag = false"
                  handle=".handle" 
                  :key="'ordenable_'+objPregunta.PREGUNTA.ID_PREGUNTA"
                >
                  <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <v-list-item
                      v-for="(item, idx) in valor7"
                      :key="'resp_' + item.RESPUESTA.ID_CAT_RESPUESTA"
                      @click=""
                    >
                      <v-list-item-avatar>
                        <v-icon
                          class="blue darken-4 white--text handle"
                        >mdi-drag</v-icon>
                      </v-list-item-avatar>
              
                      <v-list-item-content>
                        <v-list-item-title v-if="item.RESPUESTA.CAPTURA_LIBRE == false" class="text-wrap"  v-text="item.RESPUESTA.RESPUESTA"></v-list-item-title>
                        <v-list-item-title v-if="item.RESPUESTA.CAPTURA_LIBRE == true">
                          <v-text-field
                            v-model="valor7TextoLibre"
                            class="pr-5"
                            placeholder="Por favor especifique su respuesta"
                            solo
                            dense
                            :rules="[(v) => !!v || 'Campo obligatorio']"
                            :required="isValor7TextoLibre"
                            @input="setRespuesta(idSeccion, objPregunta.PREGUNTA.ID_PREGUNTA, item.RESPUESTA.ID_CAT_RESPUESTA, valor7TextoLibre, null, null)"
                            :readonly="consulta"
                            :hide-details="consulta"
                          ></v-text-field>
                        </v-list-item-title>
                        <v-list-item-subtitle>Orden: {{idx+1}}</v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action v-if="item.RESPUESTA.CAPTURA_LIBRE == true && !consulta">
                        <v-btn icon color="error" @click="isValor7TextoLibre = false; valor7TextoLibre = ''; setRespuesta(idSeccion, objPregunta.PREGUNTA.ID_PREGUNTA, item.RESPUESTA.ID_CAT_RESPUESTA, '', null, null);">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-list-item-action>
              
                    <v-list-item-action v-if="!consulta">
                        <v-btn v-if="item != valor7[0]" icon @click="arrayMove(idx, idx-1)" color="blue">
                          <v-icon color="blue">mdi-chevron-up</v-icon>
                        </v-btn>
                        <v-btn v-if="item != valor7.slice(-1)[0]" icon @click="arrayMove(idx, idx+1)" color="blue">
                          <v-icon color="blue">mdi-chevron-down</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>    

                                
                  </transition-group>
                </draggable>
              </v-list>
          <!-- <v-list two-line subheader>            
            <draggable 
              :list="valor7" 
              v-bind="dragOptions"
              @start="drag = true"
              @end="drag = false"
              handle=".handle"
              :key="'ordenable_'+objPregunta.PREGUNTA.ID_PREGUNTA"
            >
              <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                <template v-for="(item, idx) in valor7">
                  <v-list-item
                    v-if="item.RESPUESTA.CAPTURA_LIBRE == false ? true : isValor7TextoLibre"
                    :key="'preg_ord_' + objPregunta.PREGUNTA.ID_PREGUNTA + '_resp_' + item.RESPUESTA.ID_CAT_RESPUESTA"
                    @click=""
                  >
                  <v-list-item-avatar>
                        <v-icon
                          class="blue darken-4 white--text handle"
                        >mdi-drag</v-icon>
                      </v-list-item-avatar>

                  <v-list-item-avatar color="primary" size="30">
                      <span class="white--text text-h5" style="margin: 0 auto;">{{idx+1}}</span>
                    </v-list-item-avatar>
            
                    <v-list-item-content>
                      <v-list-item-title v-if="item.RESPUESTA.CAPTURA_LIBRE == false" v-text="item.RESPUESTA.RESPUESTA"></v-list-item-title>
                      <v-list-item-title v-if="item.RESPUESTA.CAPTURA_LIBRE == true">
                        <v-text-field
                          v-model="valor7TextoLibre"
                          class="pr-5"
                          placeholder="Por favor especifique su respuesta"
                          solo
                          dense
                          :rules="[(v) => !!v || 'Campo obligatorio']"
                          :required="isValor7TextoLibre"
                          @input="setRespuesta(idSeccion, objPregunta.PREGUNTA.ID_PREGUNTA, item.RESPUESTA.ID_CAT_RESPUESTA, valor7TextoLibre, null, null)"
                          :readonly="consulta"
                          :hide-details="consulta"
                        ></v-text-field>
                      </v-list-item-title>
                      <v-list-item-subtitle>Orden: {{idx+1}}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action v-if="item.RESPUESTA.CAPTURA_LIBRE == true && !consulta">
                      <v-btn icon color="error" @click="isValor7TextoLibre = false; valor7TextoLibre = ''; setRespuesta(idSeccion, objPregunta.PREGUNTA.ID_PREGUNTA, item.RESPUESTA.ID_CAT_RESPUESTA, '', null, null);">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
            
                    <v-list-item-action v-if="!consulta">
                      <v-btn v-if="item != valor7[0]" icon small @click="arrayMove(idx, idx-1)" color="blue">
                        <v-icon color="blue">mdi-chevron-up</v-icon>
                      </v-btn>
                      <v-btn v-if="item != valor7.slice(-1)[0]" icon small @click="arrayMove(idx, idx+1)" color="blue">
                        <v-icon color="blue">mdi-chevron-down</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>       

                  <v-divider
                    v-if="idx < valor7.length "
                    :key="'divider_' + idx"
                  ></v-divider>


                </template>
              </transition-group>
            </draggable>
          </v-list> -->
        </div>


      <v-snackbar
      :name="'snackbar_pregunta_encuesta_' + objPregunta.PREGUNTA.ID_PREGUNTA"
      :key="'snackbar_pregunta_encuesta_' + objPregunta.PREGUNTA.ID_PREGUNTA"
      v-model="snackbar"
      :bottom="true"
      :multi-line="true"
      :color="snackbarColor"
    >
      {{ snackbarTexto }}
      <v-btn dark text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import{ getImagenPreguntaByIdPregunta } from "@/api";
import draggable from 'vuedraggable'
import moment from 'moment'
require('moment/locale/es')

export default {
  name: 'PreguntaEncuesta',
  components: {},
  props: {
    objPregunta: {
      type: Object,
      required: true,
    },
    mostrarPregunta: {
      type: Boolean,
      default: false
    },
    idSeccion: {
      type: Number,
      required: true
    },
    setRespuesta: {
      type: Function,
      required: true
    },
    setValueParametro: {
      type: Function,
      required: true
    },
    consulta: {
      type: Boolean,
      required: true
    },
    vistaPrevia: {
      type: Boolean,
      default: false
    },
    encuestaAutenticada: {
      type: Boolean,
      default: false
    },
     mostrarPOrdenamiento:{
      type: Boolean,
      default:false
    }
  },
  data()  {
    return {
      valor1: '',
      valor2: null,
      reglas2: {
        required(value){
          return value => !!value || "Campo obligatorio";
        },
        min(value,min) {          
            return value => min != null ? value >= min || `El valor mínimo es ${min}` : true;
        },
        max(value,max) {          
            return value => max != null ? value <= max || `El valor máximo es ${max}` : true;
        }
      },

      valor3Corto: null,
      isValor3CortoTextoLibre: false,
      valor3CortoTextoLibre: '',
      valor3ValorNum: null,
      ticksLabels: [],

      valor4: [],
      isValor4TextoLibre: false,
      valor4TextoLibre: '',      

      valor5: null,
      menu: false,

      valor6: '',

      valor7: [],
      drag: false,
      isValor7TextoLibre: false,
      valor7TextoLibre: '',
      puedeValor7TextoLibre: false,

      snackbar: false,
      snackbarTexto: "",
      snackbarColor: "",

      loadingImg: false,
      imgPregunta: '',
    };
  },
  computed: {
    reglas4() {
      return [
        (this.valor4.length > 0 || this.objPregunta.PREGUNTA.REQUERIDA != true) || "Debe seleccionar por lo menos una opción"
      ];
    },
    computedFormatFecha () {
      return this.valor5 ? moment(this.valor5).format('DD [de] MMMM [de] YYYY') : ''
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: this.consulta,
        ghostClass: "ghost"
      };
    },

/*     ...mapGetters('oidc', ['oidcUser']),*/ 
  },
  watch: {
    mostrarPOrdenamiento: {
      handler(newValue, oldValue) {
       if(this.mostrarPOrdenamiento){
        if(this.objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA==7){
         this.fnAsignarValoresRespuestasOrdenables(); 
         }
        }
    }
    } ,
    valor3Corto: {
      handler(newValue, oldValue) {
        var valResp = this.objPregunta.ARREGLO_RESPUESTA.filter(n=>n.RESPUESTA.ID_CAT_RESPUESTA == newValue)[0];
        if(valResp!=undefined){
      
      var valResp =valResp.RESPUESTA;
        
        this.valor3ValorNum = 0;
        this.isValor3CortoTextoLibre = false;

        if(valResp != undefined){
          if(valResp.CAPTURA_LIBRE == true){
            this.isValor3CortoTextoLibre = true;
          }
          this.valor3ValorNum = valResp.VALOR_RESPUESTA;
        }
        
        if(this.consulta == false){
          this.valor3CortoTextoLibre = '';
        }
        else{
          this.valor3CortoTextoLibre = this.objPregunta.PREGUNTA.RESPUESTA_PREGUNTA;
          this.setRespuesta(this.idSeccion, this.objPregunta.PREGUNTA.ID_PREGUNTA, this.valor3Corto, this.valor3CortoTextoLibre, this.valor3ValorNum, this.isValor3CortoTextoLibre)
        }
 
        this.setRespuesta(this.idSeccion, this.objPregunta.PREGUNTA.ID_PREGUNTA, this.valor3Corto, this.isValor3CortoTextoLibre == true ? this.valor3CortoTextoLibre : valResp.RESPUESTA, this.valor3ValorNum, this.isValor3CortoTextoLibre)
       
       
      }

      }
      ,
    },
    valor4: {
      handler(newValue, oldValue) {

        var arrRespuestas = this.objPregunta.ARREGLO_RESPUESTA.filter(n=>newValue.includes(n.RESPUESTA.ID_CAT_RESPUESTA));

        this.isValor4TextoLibre = false;

        var respTextoLibre = arrRespuestas.filter(n=>n.RESPUESTA.CAPTURA_LIBRE == true);

        if(respTextoLibre.length > 0){          
          this.isValor4TextoLibre = true;          
        }

        if(this.consulta == false){
          this.valor4TextoLibre = '';
        }
        else{
          this.valor4TextoLibre = this.objPregunta.PREGUNTA.RESPUESTA_PREGUNTA;
          this.setRespuesta(this.idSeccion, this.objPregunta.PREGUNTA.ID_PREGUNTA, null, this.valor4TextoLibre, null, null)          
        }

        this.setRespuesta(this.idSeccion, this.objPregunta.PREGUNTA.ID_PREGUNTA, arrRespuestas, null, null, null)
      },
    },
    valor5: {
      handler(newValue, oldValue) {
        this.setRespuesta(this.idSeccion, this.objPregunta.PREGUNTA.ID_PREGUNTA, 0, newValue, 0, false)
      },
    },
    valor7: {
      
      handler(newValue, oldValue) {
       
        this.fnAsignarValoresRespuestasOrdenables();
      },
      deep: true
    },
    objPregunta:{
      handler(newValue, oldValue) {
        if(newValue.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 6){
          // if(newValue.PREGUNTA.RESPUESTA_PREGUNTA != ''){
            this.valor6 = newValue.PREGUNTA.RESPUESTA_PREGUNTA == 'paramUnd' ? '' : newValue.PREGUNTA.RESPUESTA_PREGUNTA;
            this.setRespuesta(this.idSeccion, this.objPregunta.PREGUNTA.ID_PREGUNTA, 0, this.valor6, 0, false)
          // }
        }
      },
      deep: true
    },
    isValor7TextoLibre: {
      handler(newValue, oldValue) {
        this.filtrarArrayRespuestasOrdenamiento();
      },
      deep: true
    },
    mostrarPregunta:{
      handler(newValue, oldValue) {
       // var valResp = this.objPregunta.ARREGLO_RESPUESTA.filter(n=>n.RESPUESTA.ID_CAT_RESPUESTA == newValue)[0].RESPUESTA;

        this.valor3Corto = null;
      //  this.isValor3CortoTextoLibre = false;
      }
    }
  },
  beforeMount() {

    if(this.objPregunta.PREGUNTA.TIENE_IMAGEN == true){
      this.obtenerImagenPreguntaByIdPregunta();
    }

    if(this.objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 2 && this.objPregunta.PREGUNTA.SELECTOR_NUMERICO == true){
      this.setTickLabelsSlider();
    }

    if(this.objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 7){
      this.puedeValor7TextoLibre = this.objPregunta.ARREGLO_RESPUESTA.filter(n=>n.RESPUESTA.CAPTURA_LIBRE == true).length > 0;
    }

    if(this.consulta == true){
      switch(this.objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA){
        case 1:
          this.valor1 = this.objPregunta.PREGUNTA.RESPUESTA_PREGUNTA;
          //this.setRespuesta(this.idSeccion, this.objPregunta.PREGUNTA.ID_PREGUNTA, 0, this.valor1, 0, false)
          break;
        case 2:
          this.valor2 = this.objPregunta.PREGUNTA.RESPUESTA_PREGUNTA;
          //this.setRespuesta(this.idSeccion, this.objPregunta.PREGUNTA.ID_PREGUNTA, 0, this.valor2, 0, false)
          break;
        case 3:
          var resp = this.objPregunta.ARREGLO_RESPUESTA.filter(n=>n.RESPUESTA.SELECCIONADA == true)[0];
          if(resp != undefined){
            this.valor3Corto = resp.RESPUESTA.ID_CAT_RESPUESTA;
          }
          break;
        case 4:
          var self = this;
          var resp = this.objPregunta.ARREGLO_RESPUESTA.filter(n=>n.RESPUESTA.SELECCIONADA == true);

          resp.forEach(function(item){
            self.valor4.push(item.RESPUESTA.ID_CAT_RESPUESTA);
          });
          break;
        case 5:
          this.valor5 = this.objPregunta.PREGUNTA.RESPUESTA_PREGUNTA;
          break;
        case 6:
          this.valor6 = this.objPregunta.PREGUNTA.RESPUESTA_PREGUNTA;
          this.setRespuesta(this.idSeccion, this.objPregunta.PREGUNTA.ID_PREGUNTA, 0, this.valor6, 0, false)
          break;
        case 7:

          if(this.objPregunta.PREGUNTA.RESPUESTA_PREGUNTA == ""){
            Array.prototype.push.apply(this.valor7, this.objPregunta.ARREGLO_RESPUESTA.filter(n=>n.RESPUESTA.CAPTURA_LIBRE == false));
          }
          else{
            this.isValor7TextoLibre = true;
            this.valor7TextoLibre = this.objPregunta.PREGUNTA.RESPUESTA_PREGUNTA;
            Array.prototype.push.apply(this.valor7, this.objPregunta.ARREGLO_RESPUESTA);
          }

          this.fnAsignarValoresRespuestasOrdenables();
      }

    }
    else{
      if(this.objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 6){
        this.setValueParametro(this.objPregunta, this.idSeccion)
      }

      if(this.objPregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 7){
        Array.prototype.push.apply(this.valor7, this.objPregunta.ARREGLO_RESPUESTA.filter(n=>n.RESPUESTA.CAPTURA_LIBRE == false));
        if(this.mostrarPregunta){
        this.fnAsignarValoresRespuestasOrdenables();
        }
}
    }
  },
  methods: {
    setTickLabelsSlider(){
      var self = this;
      self.ticksLabels = [];
      var dif = this.objPregunta.PREGUNTA.VALOR_MAXIMO - this.objPregunta.PREGUNTA.VALOR_MINIMO + 1

      var i;
      for (i = self.objPregunta.PREGUNTA.VALOR_MINIMO; i <= self.objPregunta.PREGUNTA.VALOR_MAXIMO; i++) {
        if(i==self.objPregunta.PREGUNTA.VALOR_MINIMO){
          self.ticksLabels.push(self.objPregunta.PREGUNTA.ETIQUETA_INICIAL);
        }
        else if(i==self.objPregunta.PREGUNTA.VALOR_MAXIMO){
          self.ticksLabels.push(self.objPregunta.PREGUNTA.ETIQUETA_FINAL);
        }
        else{
          self.ticksLabels.push("");
        }
      }

    },
    async obtenerImagenPreguntaByIdPregunta () {

      var self = this;
      self.loadingImg = true;

      self.snackbarTexto = "";
      self.snackbarColor = "";
      self.snackbar = false;

      try {
        let response = await getImagenPreguntaByIdPregunta(self.objPregunta.PREGUNTA.ID_PREGUNTA);

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              this.imgPregunta = 'data:image/png;base64,' + response.data.data.docto;
            }
          } else {
            self.snackbarTexto = "PreguntaEncuesta: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
          }
        } else {
          self.error = "Error de red";
          self.snackbarTexto = "PreguntaEncuesta: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
        }
        self.loadingImg = false;
      } catch (e) {
        self.loadingImg = false;
        self.error = e;
        self.snackbarTexto = "PreguntaEncuesta: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
    arrayMove(fromIndex, toIndex) {
      var element = this.valor7[fromIndex];
      this.valor7.splice(fromIndex, 1);
      this.valor7.splice(toIndex, 0, element);
    },
    filtrarArrayRespuestasOrdenamiento(){
      if(this.isValor7TextoLibre == true){
        this.valor7.push(this.objPregunta.ARREGLO_RESPUESTA.filter(n=>n.RESPUESTA.CAPTURA_LIBRE == true)[0])
        // if(this.objPregunta.PREGUNTA)
      }
      else{
        this.valor7 = this.valor7.filter(n=>n.RESPUESTA.CAPTURA_LIBRE == false)
        //Array.prototype.push.apply(this.valor7, this.valor7.filter(n=>n.RESPUESTA.CAPTURA_LIBRE == false));
      }
    },
    fnAsignarValoresRespuestasOrdenables(){
      this.valor7.forEach(function(value, idx){
        value.RESPUESTA.VALOR_RESPUESTA = idx+1;
      });
      this.setRespuesta(this.idSeccion, this.objPregunta.PREGUNTA.ID_PREGUNTA, null, this.valor7, 0, false) 
    }
  },
};
</script>
<style>
.small-radio i {
  font-size: 40px;
}

.small-radio .v-radio {
  padding-left: 4%;
  padding-right: 4%;
}
.small-radio [class*="__ripple"] {
  left: 0;
}

.handle {
  cursor: move !important; /* fallback if grab cursor is unsupported */
  cursor: grab !important;
  cursor: -moz-grab !important;
  cursor: -webkit-grab !important;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.handle:active, ui-widget-content:active, ui-draggable:active, ui-draggable-handle:active, .draggable2.ui-draggable-dragging {
  cursor: grabbing !important;
  cursor: -moz-grabbing !important;
  cursor: -webkit-grabbing !important;
}
</style>